import { BaseForm } from 'src/app/shared/product/baseForm';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators as val,
} from '@angular/forms';
import { ActivatedRoute, ParamMap, Route, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProviderListService } from 'src/app/dashboard/admin/report/services/gate-services/provider-list.service';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { Validators } from 'src/app/shared/validators';
import {
  IFactor,
  IMakeResponse,
  IModule,
  IOperators,
  IStatement,
  IStatementCondition,
} from '../../models/fraud-interface';
import { FraudFactorListService } from '../../services/fraud/fraud-factor-list.service';
import { FraudModuleListService } from '../../services/fraud/fraud-module-list.service';
import { FraudStatementAddService } from '../../services/fraud/fraud-statement-add.service';
import { FraudStatementGetService } from '../../services/fraud/fraud-statement-get.service';
import { FraudStatementEditService } from '../../services/fraud/fraud-statement-edit.service';
import { FraudStatementConditionsUpdateService } from '../../services/fraud/fraud-statement-conditions-update.service';
import moment from 'moment';
@Component({
  selector: 'app-manage-fraud-statment',
  templateUrl: './manage-fraud-statment.component.html',
  styleUrls: ['./manage-fraud-statment.component.scss'],
})
export class ManageFraudStatmentComponent extends BaseForm implements OnInit {
  errorMessage;
  isCreate: boolean = false;
  factors: Array<IFactor>;
  operations: Array<IOperators>;
  modules: Array<IModule>;
  statmentForm: FormGroup;
  conditionForm: FormGroup;
  id;
  moduleId;
  conditionField = {
    key: ['', [val.required]],
    op: ['', [val.required]],
    value: ['', [val.required]],
    id: [''],
    priority: [null],
  };

  timePeriod: string = 'timePeriod';

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    public formValidator: FormValidatorService,
    private translate: TranslateService,
    private getFactor: FraudFactorListService,
    private getModule: FraudModuleListService,
    private createStatement: FraudStatementAddService,
    private statementGet: FraudStatementGetService,
    private statementEdit: FraudStatementEditService,
    private conditionUpdate: FraudStatementConditionsUpdateService
  ) {
    super();
  }

  async ngOnInit() {
    try {
      this.initForm();
      this.getOperationsAndOPerations();
      this.getModules();
      this.activeRoute.paramMap.subscribe(async (paramMap: ParamMap) => {
        this.id = parseInt(paramMap.get('statement'));
        this.moduleId = parseInt(paramMap.get('id'));
        if (this.id) {
          this.statementGet.setParams({ id: this.id });
          let res: { statement: IStatement; success: boolean } =
            await this.statementGet.make();
          const data = res.statement;
          this.statmentForm.patchValue({
            statement_name: data.name,
            statement_module_id: data.module_id,
            statement_id: data.id,
          });
          data['statementConditions'].forEach((condition, index) => {
            //to convert from utc coming from db to localtime
            //which suits the angular input datetime-local
            this.addCondition();
            if (condition.key == this.timePeriod)
              condition.value = moment
                .utc(condition.value)
                .local()
                .format('YYYY-MM-DDTHH:mm');

            this.conditions.controls[index].patchValue({
              key: condition.key,
              op: condition.op,
              value: condition.value,
              id: condition.id,
              priority: condition.priority,
            });
          });
          this.cdr.detectChanges();
        } else {
          this.isCreate = true;
        }
      });
    } catch (err) {
      this.errorMessage = err.message;
    }
  }
  initForm() {
    this.statmentForm = this.formValidator.createForm([
      {
        fieldName: 'statement_name',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
              field: 'statement_name',
            }),
          },
          {
            validatorFn: CustomValidators.customPattern(/(^[a-z ]+$)/i),
            message: this.translate.instant('FormValidation.TextOnly', {
              field: 'statement_name',
            }),
          },
        ],
      },
      {
        fieldName: 'statement_module_id',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
              field: 'statement_module_id',
            }),
          },
        ],
      },
      {
        fieldName: 'statement_id',
        defaultValue: '',
      },
    ]);

    this.conditionForm = this.fb.group({
      conditions: this.fb.array([]),
    });
  }
  get conditions(): FormArray {
    return this.conditionForm.get('conditions') as FormArray;
  }
  newCondition(): FormGroup {
    return this.fb.group(this.conditionField);
  }
  addCondition(): void {
    this.conditions.push(this.newCondition());
  }
  removeCondition(i: number): void {
    this.conditions.removeAt(i);
  }
  async sendFormData() {
    if (!this.statmentForm.valid || !this.conditionForm.valid) return;
    let conditions: Array<IStatementCondition> =
      this.conditionForm.value['conditions'];
    conditions = this.adjustConditions(conditions);
    let reqData: IStatement = {
      id: this.statmentForm.value.statement_id,
      name: this.statmentForm.value.statement_name,
      module_id: this.statmentForm.value.statement_module_id,
      statementConditions: [...conditions],
    };
    if (!this.isCreate) {
      await this.editStatment(reqData);
    } else {
      await this.addStatement(reqData);
    }
  }

  setFactorDep(selectedForm: FormGroup, factorValue: string): void {
    let factor: IFactor = this.factors.find((o) => o.key === factorValue);
    selectedForm.patchValue({
      priority: factor.priority,
    });
  }
  adjustConditions(
    conditions: Array<IStatementCondition>
  ): Array<IStatementCondition> {
    //to convert from local time to utc to save in the database
    for (let i in conditions) {
      if (conditions[i].key == this.timePeriod) {
        conditions[i].value = new Date(conditions[i].value)
          .toISOString()
          .replace('T', ' ')
          .replace('Z', '')
          .slice(0, 19);
      }
    }
    return conditions;
  }
  async getOperationsAndOPerations(): Promise<void> {
    this.getFactor.setParams({});
    let result: {
      factors: Array<IFactor>;
      operators: Array<IOperators>;
      success: boolean;
    } = await this.getFactor.make();
    this.factors = Object.values(result.factors);
    this.operations = Object.values(result.operators);
    this.timePeriod = this.factors.find((o) => o.id == 9).key;
  }

  async getModules(): Promise<void> {
    this.getModule.setParams({});
    this.modules = (await this.getModule.make()).modules;
  }
  get formsValidation() {
    return !this.statmentForm.valid || !this.conditionForm.valid;
  }
  async addStatement(event: IStatement): Promise<void> {
    this.createStatement.setParams(event);
    let result: IMakeResponse = await this.createStatement.make();
    if (result.success)
      this.router.navigateByUrl(
        `admin/fraud/statement/list/${event.module_id}`
      );
    else this.errorMessage = result.message;
  }
  async editStatment(event: IStatement) {
    let statement: IStatement = {
      id: event.id,
      name: event.name,
      module_id: event.module_id,
      statementConditions: event.statementConditions,
    };
    let conditions: Array<IStatementCondition> = event.statementConditions;
    //editing statment
    this.statementEdit.setParams({ statement: statement });
    let statementResult: IMakeResponse = await this.statementEdit.make();
    //editing condition
    this.conditionUpdate.setParams({
      conditions: conditions,
      statementId: statement.id,
    });
    let conditionResult: IMakeResponse = await this.conditionUpdate.make();
    if (!statementResult.success) this.errorMessage = statementResult.message;
    if (!conditionResult.success)
      this.errorMessage += ` ${conditionResult.message}`;
    if ((statementResult.success, conditionResult.success)) {
      this.errorMessage = '';
      this.router.navigateByUrl(`admin/fraud/statement/list/${this.moduleId}`);
    }
  }
}
